/*
If you add to this file, please follow the following variable format using the information:

Format:
<TEAM>_<AREA>_<SHORT_DESCRIPTION>

Abbreviations:
- Teams:
  - CO = Consumer Ordering
  - CP = Contribution Profit
  - CX = Consumer Experience/Post Order Experience (POE)
  - GR = Growth
  - GX = Growth Experiments
  - PE = Post Order Experience
- AREAS:
  - OT = Order Tracker
  - OH = Order Help
  - OS = Order Status
  - CLP = Cuisine Landing Pages
*/

export const CO_CLICK_AND_COLLECT = 'collect_245_clients';
export const CO_HOME_GRAPHQL_EMPLOYEES = 'coh_employees';
export const CO_HOME_MOCK_ENDPOINT = 'co_home_web_mock_endpoint';
export const CO_WEB_SEARCH_EMPLOYEES = 'co_web_search_employees';
export const CO_HOMEPAGE_REDIRECT_TO_HOME = 'co_homepage_redirect_to_home';
export const CP_HIDE_MOV = 'cp_hide_mov_web';
export const CP_OT_HIDE_PROGRESS_ANIMATION = 'web_order_tracker_progress_animation';
export const CX_OH_DYNAMIC_ACTIONS_CALL_RIDER = 'order_help_dynamic_actions_call_rider_web';
export const CX_OH_NON_IFRAME = 'web_order_help_non_iframe_self_help';
export const CX_OT_CANCEL_ORDER = 'web_order_tracker_cancel_order';
export const CX_SHAREABLE_ORDER_STATUS = 'shareable_order_status_web';
export const CX_SHARING_TOKENS = 'cx_allow_sharing_tokens';
export const DELOVEROO_LOGO = 'deloveroo_logo_enabled';
export const ESCDA_AWARD_LOGO = 'web_escda_award_logo_fr';
export const GCE_306 = 'gce_306_offers_experience';
export const GDPR_PRIVACY_POLICY = 'gdpr_privacy_policy';
export const GR_CLP_BRANDS_FOOTER_LINK = 'brands_footer_link_enabled';
export const GR_CLP_CUISINES_FOOTER_LINK = 'cuisines_footer_link_enabled';
export const GR_CLP_RESTAURANTS_SECTION = 'cuisine_landing_pages_restaurants_section'; // cannot be used in code without refactor
export const GR_SEO_IMPROVEMENTS = 'snux_714_seo_audit';
export const ONETRUST_COOKIE_CONSENT = 'onetrust_cookie_consent';
export const INFO_BANNER = 'web_info_banner';
export const NEW_MARKET_HOLDING_PAGE = 'new_market_blank_holding_page';
export const NEW_MARKET_LANDING_PAGE = 'new_market_landing_enabled';
export const NEW_MARKET_LOCALE_PENDING_AR_KW = 'new_market_locale_pending_ar_kw';
export const OT_MISSED_CALL_MODAL = 'web_order_tracker_show_missed_call_modal';
export const OT_PUNCH_CARDS = 'web_order_tracker_punch_cards';
export const OT_SHOW_CHAT_IFRAME = 'show_chat_web_client_iframe';
export const RL_SEARCH = 'restaurant_list_search_web';
export const WHATSAPP_BANNER_2018 = 'display_whatsapp_info_banner_august_2018_web';
export const CLOSING_DOWN_MARKET_LANDING_PAGE = 'closing_down_market_page_enabled';
